import React, { useState, useEffect } from "react";
import {
  BoxTitle,
  ConcludedTasks,
  ContainerProd,
  DelayedConcludedTasks,
  DelayedTasks,
  ExecutionTasks,
  Block,
  LeftSide,
  NonDelegatedTasks,
  PendingTasks,
  RightLine,
  RightSide,
  RightTitle,
  SeparatorSection,
  LeftTitle,
  Toggle,
  ToggleGeral,
  ToggleSemanal,
  ToggleMensal,
  ToggleAnimation,
  Speedometer1,
  SpeedometerBackground,
  Speedometerdots,
  SpeedometerDashes1,
  SpeedometerDashes2,
  SpeedometerDashes3,
  SpeedometerValue1,
  SpeedometerValue2,
  SpeedometerValue3,
  SpeedometerPointerBase,
  SpeedometerPointerColor,
  SpeedometerPointerTop,
  SpeedometerPointer,
  SpeedomenterSuportBase,
  SpeedometerPointerPin,
  LeftBottomText,
  SpeedometerMainDash,
  HoverBox,
  HoverBoxText,
  BodySeparator,
  RightSideBody,
  MiniBlock,
  InvisibleBlocks,
  RightHeader,
  RefreshContainer,
} from "./styles";
import { CustomRefreshIcon } from "../../DeDList/styles";
import { useDispatch } from "react-redux";
import { fetchDashboardTasks } from "../../../../state/dashboard/actions";

// TG = Tasks Geral ; TS = Tasks Semanal ; TM = Tasks Mensal
const ProductiveSquare = ({
  TSDelayed = 0,
  TSPending = 1,
  TSExecution = 2,
  TSConcluded = 3,
  TSNotDelegated = 4,
  TSDeConcluded = 5,
  TMDelayed = 115,
  TMPending = 116,
  TMExecution = 117,
  TMConcluded = 118,
  TMNotDelegated = 119,
  TMDeConcluded = 120,
  TSPointer = 20,
  TMPointer = 30,
  TGDelayed = 10,
  TGPending = 20,
  TGExecution = 30,
  TGConcluded = 40,
  TGNotDelegated = 50,
  TGDeConcluded = 60,
  TGPointer = 10,
}) => {
  const dispatch = useDispatch();
  const [toggleState, setToggleState] = useState("Geral");

  const transitionTime = 150;
  const [display, setDisplay] = useState({
    delayedTasks: 0,
    delayedTasksToGoal: TGDelayed,
    executionTasks: 0,
    executionTasksToGoal: TGExecution,
    notDelegatedTasks: 0,
    notDelegatedTasksToGoal: TGNotDelegated,
    pendingTasks: 0,
    pendingTasksToGoal: TGPending,
    concludedTasks: 0,
    concludedTasksToGoal: TGConcluded,
    delayedConcludedTasks: 0,
    delayedConcludedTasksToGoal: TGDeConcluded,
    transitionSpeed:
      transitionTime /
      Math.max(
        Math.abs(TGDelayed),
        Math.abs(TGExecution),
        Math.abs(TGNotDelegated),
        Math.abs(TGPending),
        Math.abs(TGConcluded),
        Math.abs(TGDeConcluded)
      ),
  });

  function getPointerAngle(pointerValue) {
    //Posicao do ponteiro => a entrada varia entre 0 e 100
    return -180 + pointerValue * 1.8;
  }
  const pointerGeral = getPointerAngle(TGPointer);
  const pointerSemanal = getPointerAngle(TSPointer);
  const pointerMensal = getPointerAngle(TMPointer);
  const [animation, setAnimation] = useState("01");
  const animationDuration = "0.3s";
  const [pointerCounter, setPointerCounter] = useState({
    currentPointer: 0,
    currentPointerToGoal: TGPointer,
    transitionSpeed: transitionTime / TGPointer,
  });

  const [hoverBox, setHoverBox] = useState(false);
  const boxVariation = 10.5; // in rem

  function getBoxX(Value) {
    return boxVariation * Math.cos(Value * (Math.PI / 100));
  }
  function getBoxY(Value) {
    return boxVariation * Math.sin(Value * (Math.PI / 100));
  }

  const BoxXGeral = getBoxX(TGPointer);
  const BoxXSemanal = getBoxX(TSPointer);
  const BoxXMensal = getBoxX(TMPointer);
  const BoxYGeral = getBoxY(TGPointer);
  const BoxYSemanal = getBoxY(TSPointer);
  const BoxYMensal = getBoxY(TMPointer);
  const setGeral = () => {
    if (toggleState === "Semanal") {
      setAnimation("21");
    }
    if (toggleState === "Mensal") {
      setAnimation("31");
    }
    setToggleState("Geral");
    setDisplay((prev) => {
      return {
        ...prev,
        delayedTasksToGoal: TGDelayed,
        executionTasksToGoal: TGExecution,
        notDelegatedTasksToGoal: TGNotDelegated,
        pendingTasksToGoal: TGPending,
        concludedTasksToGoal: TGConcluded,
        delayedConcludedTasksToGoal: TGDeConcluded,
        transitionSpeed:
          transitionTime /
          Math.max(
            Math.abs(TGDelayed - prev.delayedTasks),
            Math.abs(TGExecution - prev.executionTasks),
            Math.abs(TGNotDelegated - prev.notDelegatedTasks),
            Math.abs(TGPending - prev.pendingTasks),
            Math.abs(TGConcluded - prev.concludedTasks),
            Math.abs(TGDeConcluded - prev.delayedConcludedTasks)
          ),
      };
    });
    setPointerCounter((prev) => ({
      ...prev,
      currentPointerToGoal: TGPointer,
      transitionSpeed:
        (transitionTime * 2) /
        Math.max(Math.abs(TGPointer - prev.currentPointer)),
    }));
  };

  const setSemanal = () => {
    if (toggleState === "Geral") {
      setAnimation("12");
    }
    if (toggleState === "Mensal") {
      setAnimation("32");
    }
    setToggleState("Semanal");
    setDisplay((prev) => ({
      ...prev,
      delayedTasksToGoal: TSDelayed,
      executionTasksToGoal: TSExecution,
      notDelegatedTasksToGoal: TSNotDelegated,
      pendingTasksToGoal: TSPending,
      concludedTasksToGoal: TSConcluded,
      delayedConcludedTasksToGoal: TSDeConcluded,
      transitionSpeed:
        transitionTime /
        Math.max(
          Math.abs(TSDelayed - display.delayedTasks),
          Math.abs(TSExecution - display.executionTasks),
          Math.abs(TSNotDelegated - display.notDelegatedTasks),
          Math.abs(TSPending - display.pendingTasks),
          Math.abs(TSConcluded - display.concludedTasks),
          Math.abs(TSDeConcluded - display.delayedConcludedTasks)
        ),
    }));
    setPointerCounter((prev) => ({
      ...prev,
      currentPointerToGoal: TSPointer,
      transitionSpeed:
        (transitionTime * 2) /
        Math.max(Math.abs(TSPointer - prev.currentPointer)),
    }));
  };

  const setMensal = () => {
    if (toggleState === "Geral") {
      setAnimation("13");
    }
    if (toggleState === "Semanal") {
      setAnimation("23");
    }
    setToggleState("Mensal");

    setDisplay((prev) => ({
      ...prev,
      delayedTasksToGoal: TMDelayed,
      executionTasksToGoal: TMExecution,
      notDelegatedTasksToGoal: TMNotDelegated,
      pendingTasksToGoal: TMPending,
      concludedTasksToGoal: TMConcluded,
      delayedConcludedTasksToGoal: TMDeConcluded,
      transitionSpeed:
        transitionTime /
        Math.max(
          Math.abs(TMDelayed - prev.delayedTasks),
          Math.abs(TMExecution - prev.executionTasks),
          Math.abs(TMNotDelegated - prev.notDelegatedTasks),
          Math.abs(TMPending - prev.pendingTasks),
          Math.abs(TMConcluded - prev.concludedTasks),
          Math.abs(TMDeConcluded - prev.delayedConcludedTasks)
        ),
    }));
    setPointerCounter((prev) => ({
      ...prev,
      currentPointerToGoal: TMPointer,
      transitionSpeed:
        (transitionTime * 2) /
        Math.max(Math.abs(TMPointer - prev.currentPointer)),
    }));
  };

  useEffect(() => {
    setTimeout(() => {
      setDisplay((prev) => {
        //comparacao paras as tarefas atrasadas
        let nextDelayedTasks = prev.delayedTasks;
        if (prev.delayedTasks < prev.delayedTasksToGoal)
          nextDelayedTasks = prev.delayedTasks + 1;
        if (prev.delayedTasks > prev.delayedTasksToGoal)
          nextDelayedTasks = prev.delayedTasks - 1;

        //comparacao para as tarefas em execusao
        let nextExecutionTasks = prev.executionTasks;
        if (prev.executionTasks < prev.executionTasksToGoal)
          nextExecutionTasks = prev.executionTasks + 1;
        if (prev.executionTasks > prev.executionTasksToGoal)
          nextExecutionTasks = prev.executionTasks - 1;

        //comparacao para as tarefas nao executadas
        let nextNotDelegatedTasks = prev.notDelegatedTasks;
        if (prev.notDelegatedTasks < prev.notDelegatedTasksToGoal)
          nextNotDelegatedTasks = prev.notDelegatedTasks + 1;
        if (prev.notDelegatedTasks > prev.notDelegatedTasksToGoal)
          nextNotDelegatedTasks = prev.notDelegatedTasks - 1;

        //comparacao para as tarefas Pendentes
        let nextPendingTasks = prev.pendingTasks;
        if (prev.pendingTasks < prev.pendingTasksToGoal)
          nextPendingTasks = prev.pendingTasks + 1;
        if (prev.pendingTasks > prev.pendingTasksToGoal)
          nextPendingTasks = prev.pendingTasks - 1;

        //comparacao para as tarefas concluidas
        let nextConcludedTasks = prev.concludedTasks;
        if (prev.concludedTasks < prev.concludedTasksToGoal)
          nextConcludedTasks = prev.concludedTasks + 1;
        if (prev.concludedTasks > prev.concludedTasksToGoal)
          nextConcludedTasks = prev.concludedTasks - 1;

        //comparacao para as tarefas concluidas com atraso
        let nextDelayedConcludedTasks = prev.delayedConcludedTasks;
        if (prev.delayedConcludedTasks < prev.delayedConcludedTasksToGoal)
          nextDelayedConcludedTasks = prev.delayedConcludedTasks + 1;
        if (prev.delayedConcludedTasks > prev.delayedConcludedTasksToGoal)
          nextDelayedConcludedTasks = prev.delayedConcludedTasks - 1;

        return {
          ...prev,
          delayedTasks: nextDelayedTasks,
          executionTasks: nextExecutionTasks,
          notDelegatedTasks: nextNotDelegatedTasks,
          pendingTasks: nextPendingTasks,
          concludedTasks: nextConcludedTasks,
          delayedConcludedTasks: nextDelayedConcludedTasks,
        };
      });
    }, display.transitionSpeed);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    display.delayedTasks,
    display.delayedTasksToGoal,
    display.executionTasks,
    display.executionToGoal,
    display.notDelegatedTasks,
    display.notDelegatedTasksToGoal,
    display.pendingTasks,
    display.pendingTasksToGoal,
    display.concludedTasks,
    display.concludedTasksToGoal,
    display.delayedConcludedTasks,
    display.delayedConcludedTasksToGoal,
  ]);

  useEffect(() => {
    setTimeout(() => {
      setPointerCounter((prev) => {
        //comparacao paras o display numerico no velocimetro
        let nextCurrentPointer = prev.currentPointer;
        if (prev.currentPointer < prev.currentPointerToGoal)
          nextCurrentPointer = prev.currentPointer + 1;
        if (prev.currentPointer > prev.currentPointerToGoal)
          nextCurrentPointer = prev.currentPointer - 1;

        return {
          ...prev,
          currentPointer: nextCurrentPointer,
        };
      });
    }, pointerCounter.transitionSpeed);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pointerCounter.currentPointer, pointerCounter.currentPointerToGoal]);

  return (
    <ContainerProd>
      <LeftSide>
        <LeftTitle>Produtividade em Fluxos Iniciados</LeftTitle>
        <BodySeparator>
          <Toggle>
            <ToggleAnimation toggleState={toggleState} />
            <ToggleGeral toggleState={toggleState} onClick={setGeral}>
              Geral
            </ToggleGeral>
            <ToggleSemanal toggleState={toggleState} onClick={setSemanal}>
              Semanal
            </ToggleSemanal>
            <ToggleMensal toggleState={toggleState} onClick={setMensal}>
              Mensal
            </ToggleMensal>
          </Toggle>
          <Speedometer1
            onMouseEnter={() => setHoverBox(true)}
            onMouseLeave={() => setHoverBox(false)}
          >
            <SpeedometerBackground />
            <Speedometerdots />
            <SpeedometerDashes1 />
            <SpeedometerDashes2 />
            <SpeedometerDashes3 />
            <SpeedometerValue1>0</SpeedometerValue1>
            <SpeedometerValue2>100</SpeedometerValue2>
            <SpeedometerValue3>50</SpeedometerValue3>
            <SpeedomenterSuportBase />
            <SpeedometerPointer
              pointerGeral={pointerGeral}
              pointerSemanal={pointerSemanal}
              pointerMensal={pointerMensal}
              animation={animation}
              animationDuration={animationDuration}
            >
              <SpeedometerPointerBase>
                <SpeedometerPointerTop />
              </SpeedometerPointerBase>
            </SpeedometerPointer>
            <SpeedometerPointerPin />
            <SpeedometerMainDash
              pointerGeral={pointerGeral}
              pointerSemanal={pointerSemanal}
              pointerMensal={pointerMensal}
              animation={animation}
              animationDuration={animationDuration}
            />
            {hoverBox ? (
              <HoverBox
                BoxXGeral={BoxXGeral}
                BoxXSemanal={BoxXSemanal}
                BoxXMensal={BoxXMensal}
                toggleState={toggleState}
                BoxYGeral={BoxYGeral}
                BoxYSemanal={BoxYSemanal}
                BoxYMensal={BoxYMensal}
              >
                <HoverBoxText>{pointerCounter.currentPointer}%</HoverBoxText>
              </HoverBox>
            ) : null}
          </Speedometer1>
          <LeftBottomText>{pointerCounter.currentPointer}/100</LeftBottomText>
        </BodySeparator>
      </LeftSide>
      <SeparatorSection>
        <InvisibleBlocks height="9%" top="0%" />
        <InvisibleBlocks height="6%" top="75%" />
        <InvisibleBlocks height="7%" top="93%" />
      </SeparatorSection>

      <RightSide>
        <RightHeader>
          <RightTitle>Resumo de Tarefas do Período</RightTitle>
          <RefreshContainer>
            <CustomRefreshIcon
              style={{ backgroundColor: "#c6c7c8", color: "#585e66" }}
              onClick={(e) => {
                dispatch(fetchDashboardTasks());
              }}
            />
          </RefreshContainer>
        </RightHeader>
        <RightSideBody>
          <RightLine>
            <Block>
              <MiniBlock>
                <BoxTitle>Atrasadas</BoxTitle>
                <DelayedTasks>{display.delayedTasks}</DelayedTasks>
              </MiniBlock>
              <MiniBlock>
                <BoxTitle>Pendentes</BoxTitle>
                <PendingTasks>{display.pendingTasks}</PendingTasks>
              </MiniBlock>
            </Block>
            <Block>
              <MiniBlock>
                <BoxTitle>Em Execução</BoxTitle>
                <ExecutionTasks>{display.executionTasks}</ExecutionTasks>
              </MiniBlock>
              <MiniBlock>
                <BoxTitle>Concluídas</BoxTitle>
                <ConcludedTasks>{display.concludedTasks}</ConcludedTasks>
              </MiniBlock>
            </Block>
            <Block>
              <MiniBlock>
                <BoxTitle>Não Delegadas</BoxTitle>
                <NonDelegatedTasks>
                  {display.notDelegatedTasks}
                </NonDelegatedTasks>
              </MiniBlock>
              <MiniBlock>
                <BoxTitle>Concluídas atrasadas</BoxTitle>
                <DelayedConcludedTasks>
                  {display.delayedConcludedTasks}
                </DelayedConcludedTasks>
              </MiniBlock>
            </Block>
          </RightLine>
        </RightSideBody>
      </RightSide>
    </ContainerProd>
  );
};

export default ProductiveSquare;
